import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "./LoginSlice";
import { logoutUser } from "./AccountLogoutThunk";

/**
 * fetch all Vendor entries
 */
export const fetchVendorItems = createAsyncThunk(
  "vendor/fetchItems",
  async ({ page = 1, search = "", limit = 20, reset = false }, thunkAPI) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendor?search=${search}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      }
    );
    
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    
    const json = await res.json();
    
    if (!res.ok) {
      throw new Error(json?.message || "Fetch failed");
    }
    
    return { ...json, reset };
  }
);

export const fetchVendorById = createAsyncThunk(
  "vendor/fetchById",
  async ({ id }, thunkAPI) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/vendor/getByParam?_id=${id}`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "x-user-role": "admin",
          },
        }
      );

      if (res.status === 401) {
        thunkAPI.dispatch(logout());
        thunkAPI.dispatch(logoutUser());
        window.location.href = "/";
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      const json = await res.json();
      if (!res.ok) {
        throw new Error(json?.message || "Fetch by id failed");
      }
      return json;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

export const updateVendorReward = createAsyncThunk(
  "vendor/updateReward",
  async (data, thunkAPI) => {
    const body = JSON.stringify({ reward: data?.reward });
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorrewardhistory?vendor_id=${data._id}`,
      {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
        body: body,
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const getVendorRewardHistory = createAsyncThunk(
  "vendor/fetchRewardItems",
  async (vendor_id, thunkAPI) => {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/vendorrewardhistory/getByParam?vendor_id=${vendor_id}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "admin",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
